import Vue from 'vue';
const isServer = Vue.prototype.$isServer;
function deepClone (parent, child) {
  if (typeof parent === "object") {
    let key, proxy, child = child || {}
    proxy = JSON.stringify(parent)
    proxy = JSON.parse(proxy)
    for (key in proxy) {
      if (proxy.hasOwnProperty(key)){
        child[key] = proxy[key]
      }
    }
    proxy = null
    return child
  }
}
function each (list,callback) {
  if (list) {
    if (list.length) {
      for (let i = 0,len = list.length; i<len; i++ ){
        if (list[i] || list[i] == 0)callback.call(this,list[i], i, list)
      }
    } else {
      for(let key in list) {
        if (list[key] || list[key] == 0) {
          callback.call(this,list[key], key, list)
        }
      }
    }
  }
}
function getScrollBarSize (fresh) {
  let cached
  if (isServer) return 0;
  if (fresh || cached === undefined) {
    const inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';

    const outer = document.createElement('div');
    const outerStyle = outer.style;

    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';

    outer.appendChild(inner);

    document.body.appendChild(outer);

    const widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);

    cached = widthContained - widthScroll;
  }
  return cached;
}
function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}
// Find components downward
function findComponentsDownward(context, componentName) {
  return context.$children.reduce((components, child) => {
    if (child.$options.name === componentName) components.push(child);
    const foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
}

// Find components upward
function findComponentUpward(context, componentName, componentNames) {
  if (typeof componentName === 'string') {
    componentNames = [componentName];
  } else {
    componentNames = componentName;
  }

  let parent = context.$parent;
  let name = parent.$options.name;
  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}

export { each, oneOf, findComponentUpward, findComponentsDownward, getScrollBarSize, deepClone };



// WEBPACK FOOTER //
// ./components/assist.js